import { apiClient } from './axios';

export interface Cookie {
  name: string;
  value: string;
  domain: string;
  path: string;
  expires: number;
  httpOnly: boolean;
  secure: boolean;
  sameSite: string;
}

export interface CrawlFbPayload {
  url: string;
  cookies: Cookie[];
}

export enum CrawlFbStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export interface CrawlFbResponse {
  id: string;
  urlCrawl: string;
  jsonAI: null;
  postImages: string[];
  aboutImages: string[];
  photosOfImages: string[];
  photosByImages: string[];
  friendsUrls: string[];
  createdAt: string;
  updatedAt: string;
  metadata: null;
  status: CrawlFbStatus;
  errorMessage: null;
  userEvent: UserEvent[];
  selectedGifts: Record<string, Gift[]>;
}

export const crawlFacebook = async (
  payload: CrawlFbPayload
): Promise<CrawlFbResponse> => {
  const response = await apiClient.post<CrawlFbResponse>(
    'facebook/crawl-with-cookies',
    payload
  );
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const getCrawlStatus = async (id: string): Promise<CrawlFbResponse> => {
  const response = await apiClient.get<CrawlFbResponse>(
    `facebook/crawls/${id}`
  );
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export interface CrawlFbListResponse {
  items: CrawlFbResponse[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
}

export const getCrawlFbList = async (
  page: number,
  limit: number
): Promise<CrawlFbListResponse> => {
  const response = await apiClient.get<CrawlFbListResponse>('facebook/crawls', {
    params: {
      page,
      limit,
      orderBy: 'createdAt:DESC',
    },
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export interface UserEvent {
  event: string;
  start_date: string;
  event_key: string;
  estimated_date: string;
  related_to: string;
}

export interface Gift {
  gift_name: string;
  price: number;
  reason: string;
}

export interface GiftRecommendationResponse {
  user_event: UserEvent[];
  selected_gifts: Record<string, Gift[]>;
}

export const getGiftRecommendations = async (
  idCrawl: string
): Promise<GiftRecommendationResponse> => {
  const response = await apiClient.post<GiftRecommendationResponse>(
    `facebook/recommend-gifts/${idCrawl}`
  );
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const deleteCrawlFb = async (id: string) => {
  return await apiClient.delete(`facebook/crawls/${id}`);
};
